"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformSanityQuiz = exports.getConfig = exports.questionToShow = exports.quizAnswerApiHandler = exports.QuizAnswerPage = exports.useQuestion = void 0;
var use_question_1 = require("./hooks/use-question");
Object.defineProperty(exports, "useQuestion", { enumerable: true, get: function () { return __importDefault(use_question_1).default; } });
var answer_1 = require("./pages/answer");
Object.defineProperty(exports, "QuizAnswerPage", { enumerable: true, get: function () { return __importDefault(answer_1).default; } });
var answer_2 = require("./pages/api/answer");
Object.defineProperty(exports, "quizAnswerApiHandler", { enumerable: true, get: function () { return __importDefault(answer_2).default; } });
var question_to_show_1 = require("./components/question-to-show");
Object.defineProperty(exports, "questionToShow", { enumerable: true, get: function () { return __importDefault(question_to_show_1).default; } });
var config_1 = require("./config");
Object.defineProperty(exports, "getConfig", { enumerable: true, get: function () { return __importDefault(config_1).default; } });
var transform_sanity_quiz_1 = require("./utils/transform-sanity-quiz");
Object.defineProperty(exports, "transformSanityQuiz", { enumerable: true, get: function () { return __importDefault(transform_sanity_quiz_1).default; } });
